import { render, staticRenderFns } from "./AccountingBooksForm.vue?vue&type=template&id=4ef4b701&"
import script from "./AccountingBooksForm.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksForm.vue?vue&type=style&index=0&id=4ef4b701&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports